<template>
    <div>
        <v-row>
            <v-col cols="12" sm="12" md="12" lg="6">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col style="height: 40px" cols="12" sm="4" md="4" lg="4">
                                <h4 style="color: #509bb0">
                                    {{ $i18n.t("Client Margin") }}
                                </h4>
                                <!-- <span style="font-size: 11px">{{ $i18n.t("Monthly") }}</span> -->
                            </v-col>
                            <v-col style="height: 28px" cols="12" sm="4" md="4" lg="4" @select="isClient == true">
                                <z-client-select v-model="client" :selectFirst="true"></z-client-select>
                            </v-col>
                            <!-- <v-col cols="3">
                                <z-month-picker style="color: red" :label="''" dense v-model="marginYearMonth" />
                            </v-col> -->
                            <v-col cols="12" sm="4" md="4" lg="4" style="height: 28px; padding-left: 0px">
                                <z-month-picker style="color: red" :label="''" dense v-model="tillYearMonth" />
                            </v-col>
                        </v-row>
                        <v-row v-if="clientValue">
                            <v-col>
                                <z-spark-line customLabel="true" :value="clientValue" :labels="clientLabel" width="1"
                                    radius="5" lineCap="round" :gradient="clientGradient"></z-spark-line>
                            </v-col>
                        </v-row>
                        <!--  <v-row>
                            <v-col class="text-right">
                                <v-btn @click="processForClient" small color="info">Get Line Chart</v-btn>
                            </v-col>
                        </v-row> -->
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="6">
                <v-card class="mx-auto text-center">
                    <v-card-text>
                        <v-row>
                            <v-col style="height: 40px" cols="12" sm="4" md="4" lg="4">
                                <h4 style="color: #509bb0">
                                    {{ $i18n.t("Supplier Margin") }}
                                </h4>
                                <!-- <span style="font-size: 11px">{{ $i18n.t("Monthly") }}</span> -->
                            </v-col>
                            <v-col style="height: 28px" cols="12" sm="4" md="4" lg="4">
                                <z-vendor-select v-model="vendor" :selectFirst="true"></z-vendor-select>
                            </v-col>
                            <!-- <v-col cols="3">
                                <z-month-picker style="color: red" :label="''" dense v-model="marginYearMonthVendor" />
                            </v-col> -->
                            <v-col cols="12" sm="4" md="4" lg="4" style="height: 28px; padding-left: 0px">
                                <z-month-picker style="color: red" :label="''" dense v-model="tillYearMonthVendor" />
                            </v-col>
                        </v-row>
                        <v-row v-if="vendorValue">
                            <v-col>
                                <z-spark-line customLabel="true" :value="vendorValue" :labels="vendorLabel" width="2"
                                    radius="10" lineCap="round" :gradient="vendorGradient"></z-spark-line>
                            </v-col>
                        </v-row>
                        <!--   <v-row>
                            <v-col class="text-right">
                                <v-btn @click="processForVendor" small color="info">Get Line Chart</v-btn>
                            </v-col>
                        </v-row> -->
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>


</template>

<script>
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { Vue, Component, Watch } from "vue-property-decorator";
@Component({
    name: "SparkSelect",
    props: {
    }
})
export default class SparkSelect extends Vue {
    client = null;
    vendor = null;
    isCLient = false;
    isVendor = false;
    /*  marginYearMonth = null; */
    tillYearMonth = null;
    //marginYearMonthVendor = null;
    tillYearMonthVendor = null;
    // clientGradient = ['#f72047', '#ffd200', '#1feaea'];
    clientGradient = ['#17a2b8'];
    vendorGradient = ['#17a2b8'];

    url = "/api/report/margin/datapoints"
    clientValue = null;
    vendorValue = null;
    clientLabel = [];
    vendorLabel = [];
    @Watch("client")
    onSelectClient() {
        this.processForClient();
    }
    @Watch("vendor")
    onSelectVendor() {
        this.processForVendor();
    }
    @Watch("tillYearMonth")
    onChangeYearMonthClient() {
        this.processForClient();
    }
    @Watch("tillYearMonthVendor")
    onChangeYearMonthVendor() {
        this.processForVendor();
    }


    async processForClient() {
        let url = this.url;
        try {
            common.setLoading(true);
            if (this.client != null && this.tillYearMonth != null) {

                this.isCLient = true;
                url = url + "?isClient=true&&corp_id=" + this.client;
                url = url + "&&tillYearMonth=" + this.tillYearMonth;
                const value = await doGet(url);
                this.clientValue = value;
            }
            common.setLoading(false);
        } catch (error) {
            common.setLoading(false);
            common.setError(error.message);
        }
        this.fillClientLabels(this.clientValue);
    }

    async processForVendor() {
        let url = this.url;
        try {
            common.setLoading(true);
            if (this.vendor != null && this.tillYearMonthVendor != null) {
                this.isVendor = true;
                url = url + "?isVendor=true&&vendor_id=" + this.vendor;
                url = url + "&&tillYearMonth=" + this.tillYearMonth;

                const value = await doGet(url);
                this.vendorValue = value;
            }
            common.setLoading(false);
        } catch (error) {
            common.setLoading(false);
            common.setError(error.message);
        }
        this.fillVendorLabels(this.vendorValue);

    }

    fillClientLabels(vas) {
        if (vas) {
            this.clientLabel = [];
            for (let i = 0; i < vas.length; i++) {
                this.clientLabel.push(vas[i].key + "(" + vas[i].value + ")");
                //this.clientLabel.push(vas[i].key);
            }
        }
    }


    fillVendorLabels(vas) {
        if (vas) {
            this.vendorLabel = [];
            for (let i = 0; i < vas.length; i++) {
                this.vendorLabel.push(vas[i].key + "(" + vas[i].value + ")");
            }
        }
    }
    setInitialDate() {
        const d = new Date();
        const year = d.getFullYear();
        let month = d.getMonth() + 1;
        month = month < 10 ? "0" + month : month;
        /* const d2 = new Date();
        d2.setMonth(d.getMonth() - 5); */
        /* const year2 = d2.getFullYear();
        let month2 = d2.getMonth() + 1; */
        /* month2 = month2 < 10 ? "0" + month2 : month2; */
        this.tillYearMonth = year + "" + month;
        /* this.marginYearMonth = year2 + "" + month2; */
        this.tillYearMonthVendor = year + "" + month;
        /*  this.marginYearMonthVendor = year2 + "" + month2; */
    }

    async mounted() {
        this.setInitialDate();
    }

}
</script>

<style>
</style>